import { createContext, useContext } from 'react';

export const AdminCtx = createContext(null);

export const useAdminCtx = () => useContext(AdminCtx);
